import React, { cloneElement, ReactElement, useCallback, useState } from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { SmartDrawer } from '../feedback/SmartDrawer';
import { Button } from '../input/Button';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';
import { CollectionStatus, UserUI } from '../users/types';

interface CollectionStatusDrawerProps {
    handleClose: VoidFunction;
    handleEditName: VoidFunction;
    title: string;
    descriptionSlot?: ReactElement;
    status?: CollectionStatus;
    modifiable?: boolean;
    currentUser?: UserUI;
    onSupportClick: VoidFunction;
}

export const CollectionStatusDrawer = (props: CollectionStatusDrawerProps) => {
    const {
        handleClose,
        handleEditName,
        title,
        descriptionSlot,
        status,
        modifiable,
        currentUser,
        onSupportClick,
    } = props;
    const [step, setStep] = useState<'OPEN' | 'CLOSE'>('OPEN');
    const onClose = useCallback(() => {
        setStep('CLOSE');
        handleClose();
    }, [handleClose]);
    const onEditName = useCallback(() => {
        setStep('CLOSE');
        handleEditName();
    }, [handleEditName]);
    const t = useTranslation();

    return (
        <SmartDrawer
            onClose={onClose}
            step={step}
            titleContent={
                <Typography
                    variant="title3"
                    weight="bold"
                    py={2}
                    dataTestId={DataTestId.COLLECTION_STATUS_DRAWER_TITLE}
                >
                    {title}
                </Typography>
            }
            mainContent={
                <>
                    {descriptionSlot ? cloneElement(descriptionSlot) : null}
                    <Flex width="100%" spacing={1} pt={2}>
                        {status === CollectionStatus.MODERATION && (
                            <Button size="l" color="primary" onClick={onClose} width="100%">
                                {t('Хорошо')}
                            </Button>
                        )}
                        {status === CollectionStatus.DECLINED && modifiable ? (
                            <Button
                                color="secondary"
                                size="l"
                                as="a"
                                href={`${process.env.REACT_APP_BETA_SUPPORT_FORM_REGULAR_LINK}?login=${currentUser?.login}`}
                                target="_blank"
                                width="100%"
                                onClick={onSupportClick}
                            >
                                {t('Обратиться в поддержку')}
                            </Button>
                        ) : null}
                        {status === CollectionStatus.DECLINED && modifiable ? (
                            <Button size="l" onClick={onEditName} color="secondary" width="100%">
                                {t('Отредактировать название')}
                            </Button>
                        ) : null}
                        {status === CollectionStatus.DECLINED && (
                            <Button size="l" onClick={onClose} color="primary" width="100%">
                                {t('Закрыть')}
                            </Button>
                        )}
                    </Flex>
                </>
            }
        />
    );
};
